<template>
  <div class="product-detail-modular">
    <div class="header-menu-bar-modular">
      <div class="menu-bar">
        <div class="menu-bar-item" v-for="(item, index) in menuBar" :key="index">
          <span class="top-bar-title" @click="toPersonCenter(index, item)">{{
            item.name
          }}</span>
          <img class="top-bar-icon" v-if="index < menuBar.length - 1" src="../assets/productDetail/top-bar-icon.png"
            alt="" />
        </div>

        <!-- <div>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">
              {{
                // pageText.homeText
                pageTextArr[0]
              }}
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{
              // pageText.productText
              pageTextArr[1]
            }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div> -->

        <!-- <div
          class="menu-bar-item"
          v-for="(item, index) in menuBar"
          :key="index"
        >
          <span class="top-bar-title" @click="toPersonCenter(index)">{{
            currLanguage==3? item.eng_title:item.title
          }}</span>
          <img
            class="top-bar-icon"
            v-if="index < menuBar.length - 1"
            src="../assets/productDetail/top-bar-icon.png"
            alt=""
          />
        </div> -->
      </div>
    </div>
    <div class="body-modualr">
      <div class="product-info-modular">
        <el-row :gutter="50">
          <el-col :span="12" :xs="24">
            <div class="banner-show-modular">
              <div class="banner-show-img-modular">
                <video :src="videoUrl" class="banner-show-img" v-if="videoUrl && showImg" autoplay="autoplay"
                  controls="controls"></video>
                <img class="banner-show-img" :src="currBannerImg" alt="" v-else />
              </div>
            </div>
            <div class="banner-tar-modualr">
              <div class="banner-tar-icon-modualr" @click="prevImg()">
                <img class="banner-tar-icon" src="../assets/productDetail/left-arrow-icon.png" alt="" />
              </div>
              <div class="banner-tar-img-modualr" v-if="productBanner">
                <div class="banner-tar-item" v-for="(item, index) in productBanner" :key="index">
                  <video :src="item.image" :class="currBannerImgIndex == index
                        ? 'banner-tar-img banner-tar-img-active'
                        : 'banner-tar-img'
                      " v-if="videoUrl && index == 0" @click="setCurrShowImg(index)"></video>
                  <img v-else :class="currBannerImgIndex == index
                        ? 'banner-tar-img banner-tar-img-active'
                        : 'banner-tar-img'
                      " :src="item.image" @click="setCurrShowImg(index)" alt="" />
                </div>
              </div>
              <div class="banner-tar-icon-modualr" @click="nextImg()">
                <img class="banner-tar-icon" src="../assets/productDetail/right-arrow-icon.png" alt="" />
              </div>
            </div>
          </el-col>
          <el-col :span="12" :xs="24">
            <div class="product-detail-info-modular">
              <div class="product-info-title">
                {{
                  currLanguage == 3
                  ? profuctInfoData.eng_title
                  : profuctInfoData.title
                }}
              </div>
              <div class="product-info-line"></div>
              <div class="product-info-explain">
                {{
                  currLanguage == 3
                  ? profuctInfoData.eng_secondtitle
                  : profuctInfoData.secondtitle
                }}
              </div>
              <div class="product-info-price-modular">
                <div class="curr-currency-modualr">
                  <!-- 2023-2-16 注释-ZLF -->
                  <!-- <div class="product-info-price-left-item">
                    <span class="select-currency-title">{{ profuctInfo.priceSelect[currPrice].type }}</span>
                    <img class="select-icon" src="../assets/product/pagination-right-icon-2.png" alt="">
                  </div> -->
                  <div class="product-info-help-item" @click="openDoubtDialog()">
                    <img class="doubt-icon" src="../assets/productDetail/doubt-icon.png" alt="" />
                    <div class="doubt-title">
                      <!-- {{ $t("translateText.havequestionsText") }}? -->
                      {{ pageTextArr[2] }}?
                    </div>
                  </div>
                </div>
                <div class="product-show-price-modualr">
                  <span class="discount-price">{{
                    currencySymbol +
                    (curr_product_has_discount == 0
                      ? showProductPrice
                      : showProductDiscountPrice)
                  }}</span>
                  <span class="original-price" v-if="curr_product_has_discount == 1">{{ currencySymbol + showProductPrice
                  }}</span>
                </div>
                <div></div>
                <div class="product-discount-modualr" v-if="profuctInfoData.coupon_data.length > 0">
                  <div class="product-discount-title">
                    {{ pageTextArr[18] }}
                  </div>
                  <div class="product-discount-bar-modualr">
                    <!-- 	cate-1折扣券cate-2现金券 其余页面以此为准 , 默认展示5个-->
                    <div class="product-discount-bar-item" v-for="(item, index) in profuctInfoData.coupon_data"
                      :key="index" v-if="index < 5">
                      <div class="discount-price-text" v-if="item.cate == 1">
                        {{
                          // $t("translateText.fullText")
                          pageTextArr[3] +
                          currencySymbol +
                          item.low_cash +
                          // $t("translateText.subtractText")
                          pageTextArr[4] +
                          parseFloat(item.discount) +
                          "%"
                        }}
                      </div>
                      <div class="discount-price-text" v-if="item.cate == 2">
                        {{
                          // $t("translateText.fullText")
                          pageTextArr[3] +
                          currencySymbol +
                          item.low_cash +
                          // $t("translateText.subtractText")
                          pageTextArr[4] +
                          currencySymbol +
                          item.cash
                        }}
                      </div>
                    </div>
                    <div v-if="profuctInfoData.coupon_data.length > 5" style="color: #ec0000">
                      ...
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-buy-modualr">
              <div class="voltage-modular" v-for="(item, index) in skuProductPriceData" :key="index">
                <div class="voltage-title">
                  {{
                    currLanguage == 3
                    ? item.eng_specification_name
                    : item.specification_name
                  }}
                </div>
                <span :class="item2.flag
                      ? 'voltage-text-active voltage-text'
                      : 'voltage-text'
                    " v-for="(item2, index2) in item.values" :key="item2.id"
                  @click="getSkuByClick(index, item.id, index2, item2.id)">{{
                    currLanguage == 3
                    ? item2.eng_specification_value
                    : item2.specification_value
                  }}
                </span>
              </div>
              <div class="quantity-modular">
                <div class="quantity-title">
                  <!-- {{ $t("translateText.quantitythText") }} -->
                  {{ pageTextArr[5] }}
                </div>
                <div class="quantity-value">
                  <!-- <inputNumber ref="inputContainerRef"></inputNumber> -->
                  <!-- <inputNumber ref="inputContainerRef" :number="parseFloat()" :index="index"></inputNumber> -->
                  <van-stepper v-model="cartNum" integer input-width="40px" button-size="28px" min="1"
                    @plus="setProducDetailtNum(1)" @minus="setProducDetailtNum(0)" />
                  <!-- @plus="cartNum++" @minus="cartNum--"  -->
                </div>
              </div>
              <div class="product-buy-cart-modualr">
                <div class="product-buy-cart-left">
                  <div>
                    <el-button class="buy-now-btn" @click="buyProductNow()">
                      <!-- {{ $t("translateText.purchaseText") }} -->
                      {{ pageTextArr[6] }}
                    </el-button>
                  </div>
                  <div>
                    <el-button class="add-to-cart-btn" @click="productAddCart(
                      profuctInfoData.id,
                      currProductSkuNumber,
                      1,
                      '',
                      cartNum
                    )
                      ">
                      <!-- {{ $t("translateText.addCartText") }} -->
                      {{ pageTextArr[7] }}
                    </el-button>
                  </div>
                </div>
                <div class="product-buy-cart-line"></div>
                <div class="product-buy-cart-right">
                  <!-- 加入收藏之后不刷新页面  -ZLF -->
                  <div class="collection-item" @click="productaddCollect(collectionFlag)">
                    <img class="collection-icon" v-if="collectionFlag == 0"
                      src="../assets/productDetail/collection-icon-1.png" alt="" />
                    <img class="collection-icon" v-else src="../assets/productDetail/collection-icon-2.png" alt="" />
                    <span class="collection-text">{{
                      // $t("translateText.collectText")
                      pageTextArr[8]
                    }}</span>
                  </div>
                  <div class="division-line"></div>
                  <div class="inquiry-item" @click="toinquiry()">
                    <img class="inquiry-icon" src="../assets/productDetail/inquiry-icon.png" alt="" />
                    <span class="inquiry-text">{{
                      // $t("translateText.enquiryText")
                      pageTextArr[9]
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="product-body-footer-modular">
        <div class="portfolio-discount-modular" v-if="portfolioList.length > 0">
          <div class="portfolio-discount-title-modular">
            <el-button class="portfolio-discount-title">{{
              // $t("translateText.combinationdiscountText")
              pageTextArr[10]
            }}</el-button>
          </div>
          <div v-if="portfolioList.length == 0" class="my-evaluate-bodu-none">
            <img class="none-icon" src="../assets/public/none-icon.png" alt="" />
            <p class="none-title">
              <!-- {{ $t("translateText.NoDataText") }} -->
              {{ pageTextArr[11] }}
            </p>
          </div>
          <div class="commodity-portfolio-show-item" v-for="(item, index) in portfolioList" :key="index">
            <el-row :gutter="10" style="width: 70%">
              <el-col :xs="24" :span="14">
                <el-row :gutter="10" style="
                      display: flex;
                      justify-content: space-between;
                      flex-wrap: wrap;
                    ">
                  <el-col :xs="12" :span="12" v-for="(item2, index2) in item.product" :key="index2">
                    <div class="show-item-produce">
                      <div class="show-item-produce-1">
                        <img class="produce-img" :src="item2.cover" alt="" />
                        <div class="produce-info">
                          {{
                            currLanguage == 3 ? item2.eng_title : item2.title
                          }}
                        </div>
                        <div class="produce-price">
                          {{ currencySymbol + item2.price }}
                        </div>
                      </div>
                      <div class="show-item-produce-add" v-if="isShowAddIcon(index2, item.product.length)">
                        <img class="portfolio-add-icon" src="../assets/commodity-portfolio/portfolio-icon-1.png" alt="" />
                      </div>
                      <!-- <div v-else style="width: 40px;height: 40px;border:1px solid red;">
                      </div> -->
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="24" :span="9">
                <div class="portfolio-price-modualr">
                  <div class="commodity-portfolio-show-item-center">
                    <img class="portfolio-center-icon" src="../assets/commodity-portfolio/portfolio-icon-2.png" alt="" />
                  </div>
                  <div class="show-price-modular">
                    <div class="portfolio-price">
                      <span class="portfolio-pric-title">{{
                        // $t("translateText.combinedpriceText")
                        pageTextArr[12] + "："
                      }}</span>
                      <span class="portfolio-pric-num">{{
                        currencySymbol + item.total_discount_price
                      }}</span>
                    </div>
                    <div class="savings-price">
                      <span class="savings-pric-title">{{
                        // $t("translateText.economizeText")
                        pageTextArr[13] + "："
                      }}</span>
                      <span class="savings-pric-num">{{
                        currencySymbol + item.discount_price
                      }}</span>
                    </div>
                    <div class="btn-modualr">
                      <el-button class="buy-btn" @click="buyProductNowCombinedGoods(
                            item,
                            item.total_discount_price
                          )
                          ">
                        <!-- {{ $t("translateText.buynowText") }} -->
                        {{ pageTextArr[6] }}
                      </el-button>
                      <el-button class="add-btn" @click="productAddCart('', item.number, 2, item.middle_id, 1)
                        ">
                        <!-- {{ $t("translateText.addCartText") }} -->
                        {{ pageTextArr[7] }}
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="product-introduce-evaluate-modualr">
          <div class="product-introduce-evaluate-title-modular">
            <el-button :class="currtarFlag == 0
                ? 'introduce-title active-title'
                : 'introduce-title'
              " @click="changeActiveTar(0)">
              <!-- {{ $t("translateText.introduceText") }} -->
              {{ currLanguage == 3 ? "Details" : pageTextArr[14] }}
            </el-button>
            <el-button :class="currtarFlag == 1
                ? 'evaluate-title active-title'
                : 'evaluate-title'
              " @click="changeActiveTar(1)">
              <!-- {{ $t("translateText.appraiseText") }} -->
              {{ currLanguage == 3 ? "Customer Review" : pageTextArr[15] }}
              ({{ appraiseNum }})</el-button>
          </div>
          <div class="product-introduce-evaluate-show-modualr">
            <div class="product-introduce-show-modualr" v-if="currtarFlag == 0">
              <div v-if="profuctInfoData.body == '' || profuctInfoData.eng_body == ''
                " class="my-evaluate-bodu-none">
                <img class="none-icon" src="../assets/public/none-icon.png" alt="" />
                <p class="none-title">
                  <!-- {{ $t("translateText.NoDataText") }} -->
                  {{ pageTextArr[11] }}
                </p>
              </div>
              <div v-else v-html="currLanguage == 3
                  ? profuctInfoData.eng_body
                  : profuctInfoData.body
                " class="product-introduce-show-content"></div>
            </div>
            <div class="product-evaluate-show-modualr" v-else>
              <el-row :gutter="10" style="width: 100%">
                <el-col :span="8" :xs="24" style="display: flex">
                  <div class="product-evaluate-show-left-modular">
                    <div class="evaluate-stars-modualr-title">
                      <van-rate v-model="evaluateList.stars" :size="25" color="#ff7a4d" void-icon="star" void-color="#eee"
                        readonly />
                      <!-- <img class="stars-icon"
                        v-for="(item, index1) in  getsStarScalculation(evaluateList.stars).starsFlag1"
                        src="../assets/productDetail/stars-icon-1.png" alt="" :key="index1">
                      <img class="stars-icon"
                        v-for="(item, index2) in  getsStarScalculation(evaluateList.stars).starsFlag2"
                        src="../assets/productDetail/stars-icon-0.png" alt="" :key="index2">
                      <img class="stars-icon"
                        v-for="(item, index3) in  getsStarScalculation(evaluateList.stars).starsFlag0"
                        src="../assets/productDetail/stars-icon-1.png" alt="" :key="index3"> -->
                    </div>
                    <div class="evaluate-liet-length">
                      {{ productCommentTotal }}
                      <!-- {{ $t("translateText.buyermycommentsText") }} -->
                      {{ pageTextArr[16] }}
                    </div>
                    <div class="progress-stars-modular">
                      <div class="progress-stars-item">
                        <div class="progress-stars-title">
                          5
                          <!-- {{ $t("translateText.starText") }} -->
                          {{ pageTextArr[17] }}
                        </div>
                        <el-progress :percentage="getStarsProportion().five.toFixed(0)" :stroke-width="20"
                          color="#FF794D"></el-progress>
                      </div>
                      <div class="progress-stars-item">
                        <div class="progress-stars-title">
                          4
                          <!-- {{ $t("translateText.starText") }} -->
                          {{ pageTextArr[17] }}
                        </div>
                        <el-progress :percentage="getStarsProportion().four.toFixed(0)" :stroke-width="20"
                          color="#FF794D"></el-progress>
                      </div>
                      <div class="progress-stars-item">
                        <div class="progress-stars-title">
                          3
                          <!-- {{ $t("translateText.starText") }} -->
                          {{ pageTextArr[17] }}
                        </div>
                        <el-progress :percentage="getStarsProportion().three.toFixed(0)" :stroke-width="20"
                          color="#FF794D"></el-progress>
                      </div>
                      <div class="progress-stars-item">
                        <div class="progress-stars-title">
                          2
                          <!-- {{ $t("translateText.starText") }} -->
                          {{ pageTextArr[17] }}
                        </div>
                        <el-progress :percentage="getStarsProportion().two.toFixed(0)" :stroke-width="20"
                          color="#FF794D"></el-progress>
                      </div>
                      <div class="progress-stars-item">
                        <div class="progress-stars-title">
                          1
                          <!-- {{ $t("translateText.starText") }} -->
                          {{ pageTextArr[17] }}
                        </div>
                        <el-progress :percentage="getStarsProportion().one.toFixed(0)" :stroke-width="20"
                          color="#FF794D"></el-progress>
                      </div>
                    </div>
                  </div>
                  <div class="product-evaluate-show-line-modular"></div>
                </el-col>
                <el-col :span="16" :xs="24">
                  <div class="product-evaluate-show-right-modular">
                    <div v-if="productCommentList.length == 0" class="my-evaluate-bodu-none">
                      <img class="none-icon" src="../assets/public/none-icon.png" alt="" />
                      <p class="none-title">
                        <!-- {{ $t("translateText.NoDataText") }} -->
                        {{ pageTextArr[11] }}
                      </p>
                    </div>
                    <div class="product-evaluate-list-modular">
                      <div class="product-evaluate-item" v-for="(item, index) in productCommentList" :key="index">
                        <div class="product-evaluate-item-left">
                          <img class="user-face" :src="item.face == ''
                              ? 'https://admin.ginkgoem.cn/Upload/image/20230216/4f5f83078d0b203c680440409f1e080d.png'
                              : item.face
                            " alt="" />
                        </div>
                        <div class="product-evaluate-item-right">
                          <div class="user-name">
                            {{ item.surname + item.name }}
                          </div>
                          <div class="stars-num-show">
                            <van-rate v-model="item.star" :size="25" color="#ff7a4d" void-icon="star" void-color="#eee"
                              readonly />

                            <!-- <img class="stars-icon" v-for="item in getsStarScalculation(item.star).starsFlag1"
                              src="../assets/productDetail/stars-icon-1.png" alt="" :key="item">
                            <img class="stars-icon" v-for="item in getsStarScalculation(item.star).starsFlag2"
                              src="../assets/productDetail/stars-icon-0.png" alt="" :key="item">
                            <img class="stars-icon" v-for="item in getsStarScalculation(item.star).starsFlag0"
                              src="../assets/productDetail/stars-icon-1.png" alt="" :key="item"> -->
                          </div>
                          <div class="product-evaluate-content">
                            <div v-html="item.comment"></div>
                          </div>
                          <div :class="item.pics.split(',').length > 4 && showMore
                              ? 'product-evaluate-img-modular overflow-product-evaluate-img-modular'
                              : 'product-evaluate-img-modular'
                            " v-if="item.pics">
                            <div class="product-evaluate-img-item" v-for="(item2, index2) in item.pics.split(',')"
                              :key="index2" v-if="index2 < showImgNum">
                              <img class="show-img" :src="item2" alt="" />
                            </div>
                            <div v-if="item.pics.split(',').length > 4 && !showMore
                              " @click="moreImgItem">
                              <i class="el-icon-arrow-right"></i>
                            </div>
                            <div v-if="item.pics.split(',').length > 4 && showMore" @click="moreleftImgItem">
                              <i class="el-icon-arrow-left"></i>
                            </div>
                          </div>

                          <div class="product-evaluate-date">
                            {{ item.create_time }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pagination-footer-modualr">
                      <el-pagination :pager-count="11" background layout="prev, pager, next" :total="pageCount"
                        @current-change="handleCurrentChange()">
                      </el-pagination>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 疑问 -->
    <el-dialog :title="pageTextArr[2]" :visible.sync="isShowDialogDoubt" :close-on-click-modal="false"
      @close="closeDialog">
      <div class="doubt-dialog-modular">
        <!-- <el-row :gutter="20">
          <el-col :span="8" :xs="24"> -->
        <div class="img-info-item">
          <div class="img-item">
            <img class="product-img" :src="profuctInfoData.cover" alt="" />
          </div>
          <div class="info-item">
            {{
              currLanguage == 3
              ? profuctInfoData.eng_title
              : profuctInfoData.title
            }}
          </div>
        </div>
        <!-- </el-col>
          <el-col :span="16" :xs="24"> -->
        <div class="doubt-submit-item">
          <el-input class="doubt-submit-email doubt-submit-input" v-model="submitInfo.email"
            :placeholder="pageTextArr[19]"></el-input>
          <el-input type="textarea" rows="10" class="doubt-submit-commit doubt-submit-input"
            :placeholder="pageTextArr[20]" v-model="submitInfo.commit" maxlength="200" show-word-limit></el-input>
          <div class="upload-modular">
            <div class="title">
              {{ pageTextArr[21] }}
            </div>
            <div class="upload-item">
              <div>
                <!-- <img class="upload-img-item" :src="item" alt="" v-for="(item, index) in uploadImgData" :key="index" /> -->
              </div>
              <el-upload class="avatar-uploader" :action="uploadUrl" :headers="headerData"
                :before-upload="beforeFileUpload" :on-success="uploadImgSeccess" list-type="picture-card"
                :file-list="fileList">
                <img v-if="dialogImageUrl" :src="dialogImageUrl" class="avatar" />
                <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                <img src="../assets/productDetail/upload.png" alt="" srcset="" style="width: 122px; height: 122px" />
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-delete" @click="handleRemove(file)">{{ pageTextArr[25] }}
                      <!-- <i class="el-icon-delete"></i> -->
                    </span>
                  </span>
                </div>
              </el-upload>
            </div>
            <div class="submit-modular">
              <el-button class="submit-btn" @click="sunmitEnquiry()">{{
                pageTextArr[22]
              }}</el-button>
            </div>
          </div>
        </div>
        <!-- </el-col>
        </el-row> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import inputNumber from "../components/public/InputNumber";

export default {
  components: {
    inputNumber,
  },
  data() {
    return {
      appraiseNum: 0, //评价数量
      currencySymbol: localStorage.getItem("currencySymbol"),
      time_discount_id: "",
      page: 1,
      pagesize: 10,
      pageCount: 1,
      currLanguage: 1, //当前语言
      productId: "", // 产品详情ID
      productTypeId: "", //分类ID
      // 上传
      uploadUrl:
        localStorage.getItem("genericBaseUrl") + "/Home/Common/uploadimage",
      headerData: {}, //上传图片的header参数
      uploadImgData: [], //上传的图片
      uploading: "",
      dialogImageUrl: "",
      fileList: [],
      showDialogDoubtWidth: "65%",
      cartNum: 1, //购物车数量
      isShowDialogDoubt: false, //疑问弹窗
      currProductSkuNumber: "", //当前商品的skunumber
      menuBar: [
        {
          name: "首页",
          // eng_title: "Home",
        },
        {
          name: "产品系列名",
          // eng_title: "Prodect series",
        },
      ],
      currPrice: 0,
      profuctInfoData: {}, //善品详情-信息
      collectionFlag: 0, //1-已收藏，0-没有
      showProductPrice: "", //商品原价
      showProductDiscountPrice: "", //商品折扣价
      defaultSkuindex: 0, //默认选择的
      skuProductPriceData: [], //规格的价格数据
      productBanner: [], //产品轮播
      showImg: true,
      currBannerImg: "", //当前轮播图片
      videoUrl: "",
      currBannerImgIndex: 0, //当前轮播图片的index
      productSku: [], //选中的Sku'
      productCommentList: [], //评论列表
      showMore: false,
      showImgNum: 5,
      productStarData: [], //评论星级数据
      productCommentTotal: 0, //评论数量
      curr_product_has_discount: 0, //0-没有优惠，1-有优惠
      has_wholesale_price: 0, //是否有批发价 1-有
      wholesale_price_id: "", //批发价id
      profuctInfo: {
        productImg: require("../assets/home/commodity-show-img.png"),
        title: "高速全自动SMT贴片机SMT-π8(SMT-Pi8)厂家直供PCB组装机械",
        explain:
          "SMT机Pi8采用大理石台面，保证精度，机械机构不易变形。 CCD摄像头和高清摄像头采用闪光识别技术",
        priceSelect: [],
      },
      pageTextArr: [
        "首页",
        "产品系列",
        "有疑问",
        "消费满足",
        "减去",
        "数量",
        "立即购买",
        "加入购物车",
        "收藏",
        "询价",
        "组合优惠",
        "暂无数据",
        "组合价",
        "节省",
        "介绍",
        "评价",
        "买家评论",
        "星",
        "优惠",
        "你的邮箱",
        "请填写你的问题",
        "请上传JPG/GIF/PNG文件。图片大小不能超过2MB。",
        "提交",
        "请填写邮箱",
        "请填写内容",
        "删除",
      ],
      quantity: 0,
      portfolioList: [], //组合商品列表
      currtarFlag: 0, //0-介绍,1-评价
      starsFlag0: 0, //空星星
      starsFlag1: 0, //完整星星
      starsFlag2: 0, //半星星
      evaluateList: {
        stars: 0, //评价星级
        progress: {
          one: 0,
          two: 0,
          three: 10,
          four: 10,
          five: 80,
        },
      },
      submitInfo: {
        email: "",
        commit: "",
        imgUrlList: [],
      },
      categoryList: [],
    };
  },
  methods: {
    /**
     * 判断是否显示+
     * @param {*} index
     * @param {*} length
     */
    isShowAddIcon(index, length) {
      let that = this;
      let isShowFlag = false;
      if ((index + 1) % 2 == 1) {
        if (length - 1 == index) {
          isShowFlag = false;
        } else {
          isShowFlag = true;
        }
      }
      return isShowFlag;
    },
    /**
     * 展示评价中的更多图片
     */
    moreImgItem() {
      console.log("moreImgItem");
      this.showMore = true;
      this.showImgNum = 100;
    },
    moreleftImgItem() {
      this.showMore = false;
      this.showImgNum = 5;
    },

    /**
     * 分页点击
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.page = val;
      this.getCommentList();
    },

    /**
     * 上传loading
     */
    uploadLoading() {
      let that = this;
      that.uploading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },

    /**
     * 上传文件前判断
     * @param {*} file
     */
    beforeFileUpload(file) {
      // console.log("FILE", file);
      this.uploadLoading();
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传文件只能是JPG格式!");
        this.fileList = [];
      }
      if (!isLt2M) {
        this.$message.error("上传xlsx表格文件且不能超过 5MB!");
        this.fileList = [];
      }
      return isJPG && isLt2M;
    },

    /**
     * 上传完成之后
     * @param {*} res
     * @param {*} file
     */
    uploadImgSeccess(res, file, fileList) {
      let that = this;
      that.uploading.close();
      if (res.ret == 1) {
        that.fileList = fileList;
        that.uploadImgData.push(res.data.file_url);
      } else {
        that.$message({ title: "警告", message: res.msg, type: "error" });
      }
    },

    /**
     *
     * 图片上传前判断
     * @param {*} file
     */
    beforeAvatarUpload(file) {
      console.log("file", file.type);
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleChange(value) {
      console.log(value);
    },

    handleRemove(file) {
      let url = file.response.data.file_url;
      let index = this.uploadImgData.findIndex((item) => {
        return item === url;
      });
      this.uploadImgData.splice(index, 1);
      this.fileList.splice(index, 1);
    },

    /**
     * 介绍，评级，切换
     * @param {*} value
     */
    changeActiveTar(value) {
      let that = this;
      that.currtarFlag = value;
    },

    /**
     * 星星数量
     * @param {*} startNum
     */
    getsStarScalculation(startNum) {
      let num = {
        starsFlag0: 0,
        starsFlag1: 0,
        starsFlag2: 0,
      };
      let that = this;
      // 向下取证获取完成的星星数量
      num.starsFlag1 = Math.floor(startNum);
      // 获取半个星星的数量
      num.starsFlag0 = Math.ceil(startNum - Math.floor(startNum));
      // 5减去向上取整获取空的星星数量
      num.starsFlag2 = 5 - Math.ceil(startNum);

      return num;
    },

    /**
     * 跳转询价
     */
    toinquiry() {
      let that = this;
      if (this.$parent.tipsLogin()) return;
      this.$router.push({
        path: "/inquiryManagement",
        query: { product_id: that.productId },
      });
    },

    /**
     * 加入收藏
     * @param {*} type
     */
    productaddCollect(type) {
      let that = this;
      if (this.$parent.tipsLogin()) return;
      that.$parent.productCollect(
        that.profuctInfoData.id,
        type,
        (res) => {
          if (res.ret == 1) {
            if (type == 0) {
              that.collectionFlag = true;
            } else {
              that.collectionFlag = false;
            }
            this.$message.success(res.msg);
          } else {
            that.collectionFlag = false;
            this.$message.error(res.msg);
          }
        },
        (res) => {
          that.collectionFlag = false;
          this.$message.error(res.msg);
        }
      );
    },

    /**
     * 打开疑问弹窗
     */
    openDoubtDialog() {
      this.isShowDialogDoubt = true;
    },

    /**
     * 关闭弹窗操作
     */
    closeDialog() { },

    /**
     * 判断是手机还是PC
     */
    judgePcOrPhone() {
      let that = this;
      let type = localStorage.getItem("equipmentType");
      if (type == 1) {
        that.showDialogDoubtWidth = "95%";
      } else {
        that.showDialogDoubtWidth = "65%";
      }
    },

    /**
     * 产品详情
     */
    getProductDetail() {
      let that = this;
      let data = {
        product_id: that.productId, //产品ID
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
      };
      this.$http.getProductDetail(
        data,
        (res) => {
          if (res.ret == 1) {
            // 添加导航栏
            if (res.typeDat) {
              res.typeDat;
            }
            that.menuBar.push(...res.typeData);
            console.log(that.menuBar);
            that.translateApiData1(that.menuBar, "name", -1);
            // 更改title
            document.title =
              that.currLanguage == 3 ? res.data.eng_title : res.data.title;
            // 更改meata
            document
              .querySelector('meta[name="Keywords key3"]')
              .setAttribute(
                "content",
                that.currLanguage == 3 ? res.data.eng_title : res.data.title
              );
            // 评价数量
            that.appraiseNum = res.comment_num;
            // 商品信息
            that.profuctInfoData = res.data;

            if (
              that.profuctInfoData &&
              this.currLanguage != 3 &&
              this.currLanguage != 1
            ) {
              that.translateApiData(that.profuctInfoData, "1", "productinfo");
            }
            // 组合商品
            if (res.portfolio_data != "") {
              that.portfolioList = res.portfolio_data;

              if (
                that.portfolioList &&
                this.currLanguage != 3 &&
                this.currLanguage != 1
              ) {
                that.translateApiData(that.portfolioList, "1", "portfolioList");
              }
            }


            // 收藏
            that.collectionFlag = res.is_collect;
            // 产品ID
            that.productId = res.data.id;
            // 分类ID
            that.productTypeId = res.data.typeid;
            // 商品-规格
            if (res.data.keydata != "") {
              that.skuProductPriceData = res.data.keydata;
              if (
                that.skuProductPriceData.length > 0 &&
                this.currLanguage != 3 &&
                this.currLanguage != 1
              ) {
                that.translateApiData(that.skuProductPriceData, "1", "sku");
              }
            }

            // 商品轮播
            // console.log('res.data.pics', res.data.pics);
            if (
              res.data.pics != "" &&
              res.data.pics != null &&
              res.data.pics != "null"
            ) {
              that.productBanner = JSON.parse(res.data.pics);
              if (res.data.video) {
                that.productBanner.unshift({
                  image: res.data.video,
                });
              }
              that.videoUrl = res.data.video;
              // that.productBanner = res.data.pics.split(',');
              // 轮播当前图片
              that.currBannerImg = that.productBanner[0].image;
            } else {
              that.currBannerImg = res.data.cover; //require('../assets/public/none-icon.png')
              that.productBanner.push({
                image: res.data.cover,
              });
            }

            // 获取商品价格
            that.getDefaultSkuPrice();
            // 商品评价列表
            that.getCommentList();
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 通过点击后去Sku
     * @param {*} index
     * @param {*} ParentId
     * @param {*} childrenindex
     * @param {*} id
     */
    getSkuByClick(index, ParentId, childrenindex, id) {
      // console.log('index', index, 'ParentId', ParentId, 'childrenindex',childrenindex,'id', id);
      let that = this;
      that.productSku[index][0] = ParentId;
      that.productSku[index][1] = id;
      // 数据更改赋值
      let etitData = that.skuProductPriceData[index];
      etitData.values.forEach((v, i) => {
        v.flag = false;
      });
      etitData.values[childrenindex].flag = true;
      that.$set(that.skuProductPriceData, index, etitData);

      // 商品价格
      that.getDetailPriceBySku();
    },

    /**
     * 获取默认的规格
     */
    getDefaultSkuPrice() {
      let that = this;
      let specification = [];
      that.skuProductPriceData.forEach((v, i) => {
        specification.push([v.id]);
        if (v.values.length > 0) {
          v.values.forEach((v2, i2) => {
            if (i2 == 0 && v2.specification_key_id == v.id) {
              specification[i].push(v2.id);
              v2.flag = true;
            } else {
              v2.flag = false;
            }
            // 设施状态
          });
        }
      });
      that.productSku = specification;
      // 商品价格
      that.getDetailPriceBySku();
    },

    /**
     * 更改商品详情的价格数量
     * @param {*} type 1-加 0-减
     */
    setProducDetailtNum(type) {
      let that = this;
      if (this.$parent.tipsLogin()) return;
      if (type == 1) {
        that.cartNum++;
      } else {
        that.cartNum--;
      }
      // 商品价格
      that.getDetailPriceBySku();
    },

    /**
     * 商品价格
     */
    getDetailPriceBySku() {
      let that = this;
      let data = {
        product_id: that.productId, //产品ID
        typeid: that.productTypeId, //分类ID
        specification: that.productSku, //商品规格
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
        exchange_rate_symbol: localStorage.getItem("currencySymbol"), //汇率值符号
        num: that.cartNum, //商品数量
      };
      this.$http.getDetailPriceBySku(
        data,
        (res) => {
          if (res.ret == 1) {
            //商品原价
            that.showProductPrice = res.data.price;
            //商品折扣价
            that.showProductDiscountPrice = res.data.discount_price;
            // Sku-number
            that.currProductSkuNumber = res.data.sku_number;
            // 是否有优惠
            that.curr_product_has_discount = res.data.has_discount;
            //
            that.time_discount_id = res.data.time_discount_id;
            // 批发价
            that.has_wholesale_price = res.data.has_wholesale_price;
            // 批发价ID
            that.wholesale_price_id = res.data.wholesale_price_id;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 商品评价列表
     */
    getCommentList() {
      let that = this;
      let data = {
        product_id: that.productId, //产品ID
        page: that.page,
        pagesize: that.pagesize,
      };
      this.$http.getCommentList(
        data,
        (res) => {
          if (res.ret == 1) {
            //评论列表
            that.productCommentList = res.data;
            if (that.productCommentList.length > 0) {
              that.languageTranslateByArrs(that.productCommentList, 2);
            }
            // 评论星级数据
            that.productStarData = res.comment_data;
            // 多少条评论
            that.productCommentTotal = parseInt(res.total);
            // 评价星级
            that.evaluateList.stars = res.star_avage;
            // 星级数量占比
            that.getStarsProportion();
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 星级占比
     */
    getStarsProportion() {
      let that = this;
      let starsProportion = {
        one: 0,
        two: 0,
        three: 0,
        four: 0,
        five: 0,
      };
      that.productStarData.forEach((v, i) => {
        switch (parseInt(v.star)) {
          // 一星
          case 1:
            starsProportion.one = (v.total / that.productCommentTotal) * 100;
            break;
          // 二星
          case 2:
            starsProportion.two = (v.total / that.productCommentTotal) * 100;
            break;
          // 三星
          case 3:
            starsProportion.three = (v.total / that.productCommentTotal) * 100;
            break;
          // 四星
          case 4:
            starsProportion.four = (v.total / that.productCommentTotal) * 100;
            break;
          // 五星
          case 5:
            starsProportion.five = (v.total / that.productCommentTotal) * 100;
            break;

          default:
            break;
        }
      });
      return starsProportion;
    },
    /**
     * 图片点击
     * @param {*} index
     */
    setCurrShowImg(index) {
      let that = this;
      if (index == 0) {
        that.showImg = true;
        that.currBannerImgIndex = index;
      } else {
        that.showImg = false;
        // 商品轮播下标
        that.currBannerImgIndex = index;
        // 轮播当前图片
        that.currBannerImg = that.productBanner[index].image;
      }
    },

    /**
     * 上一张图片
     */
    prevImg() {
      let that = this;
      // that.currBannerImgIndex--;
      console.log("that.currBannerImgIndex", that.currBannerImgIndex);
      // 商品轮播下标
      if (that.currBannerImgIndex == 0) {
        that.currBannerImgIndex = that.productBanner.length - 1;
        that.showImg = false;
        that.currBannerImg = that.productBanner[that.currBannerImgIndex].image;
      } else if (that.currBannerImgIndex > 0) {
        that.currBannerImgIndex--;
        that.currBannerImg = that.productBanner[that.currBannerImgIndex].image;

        // 轮播当前图片
        if (that.currBannerImgIndex == 0) {
          that.showImg = true;
        }
      }
    },

    /**
     * 下一站图片
     */
    nextImg() {
      let that = this;
      console.log("that.currBannerImgIndex", that.currBannerImgIndex);

      // 商品轮播下标
      if (that.currBannerImgIndex == that.productBanner.length - 1) {
        that.currBannerImgIndex = 0;
        that.showImg = true;
      } else {
        that.currBannerImgIndex++;
        that.showImg = false;
        console.log("that.currBannerImgIndex-------", that.currBannerImgIndex);

        // 轮播当前图片
        that.currBannerImg = that.productBanner[that.currBannerImgIndex].image;
      }
    },

    /**
     * 立即购买-单品
     */
    buyProductNow() {
      let that = this;
      if (this.$parent.tipsLogin()) return;
      let productPrice =
        that.curr_product_has_discount == 0
          ? that.showProductPrice
          : that.showProductDiscountPrice;
      that.settlement(productPrice);
    },

    /**
     * 结算-单品结算
     */
    settlement(price) {
      let that = this;
      // 清除
      localStorage.removeItem("localStorageProductData");
      let data = {
        price: price * that.cartNum,
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
        exchange_rate_symbol: localStorage.getItem("currencySymbol"),
      };
      let productData = [];
      productData.push({
        product_id: that.profuctInfoData.id,
        sku_number: that.currProductSkuNumber,
        type: 1,
        num: that.cartNum,
        typeid: that.profuctInfoData.typeid,
        has_discount: that.curr_product_has_discount,
        has_wholesale_price: that.has_wholesale_price,
        wholesale_price_id: that.wholesale_price_id,
        cart_id: "",
        portfolio_sales_middle_id: "", //组合id
        price: that.showProductPrice,
        discount_price: that.showProductDiscountPrice,
        time_discount_id: that.time_discount_id,
      });
      let localStorageProductData = {
        productData: productData,
        productPrice: data.price,
      };
      // console.log('productData--',productData);
      // return
      localStorage.setItem(
        "localStorageProductData",
        JSON.stringify(localStorageProductData)
      );
      this.$router.push({
        path: "/confirmOrder",
      });
    },

    /**
     * 立即购买-组合商品
     * @param {*} item
     * @param {*} price
     */
    buyProductNowCombinedGoods(item, price) {
      let that = this;
      if (this.$parent.tipsLogin()) return;
      that.settlementCombinedGoods(item, price);
    },

    /**
     * 立即购买 -组合商品
     * @param {*} item
     * @param {*} price
     */
    settlementCombinedGoods(item, price) {
      let that = this;
      let productData = [];
      productData.push({
        product_id: item.product[0].id,
        sku_number: item.product[0].number,
        type: 2,
        num: 1,
        typeid: item.product[0].typeid,
        has_discount: that.curr_product_has_discount,
        has_wholesale_price: that.has_wholesale_price,
        wholesale_price_id: that.wholesale_price_id,
        cart_id: "",
        portfolio_sales_middle_id: item.middle_id,
        time_discount_id: "",
      });
      let localStorageProductData = {
        productData: productData,
        productPrice: price,
      };
      localStorage.setItem(
        "localStorageProductData",
        JSON.stringify(localStorageProductData)
      );
      this.$router.push({
        path: "/confirmOrder",
      });
    },
    /**
     * 加入购物车
     * @param {*} product_id
     * @param {*} sku_number
     * @param {*} type
     * @param {*} portfolio_sales_middle_id
     * @param {*} cartNum
     */
    productAddCart(
      product_id,
      sku_number,
      type,
      portfolio_sales_middle_id,
      cartNum
    ) {
      let that = this;
      // if (this.$parent.tipsLogin()) return;
      // return
      that.$parent.addCart(
        product_id,
        sku_number,
        type,
        portfolio_sales_middle_id,
        cartNum
      );
    },

    /**
     * 更改数量
     */
    setProductNum(index, number) {
      let that = this;
      that.shoppCartProductList[index].product_data[0].num = number;
      // that.setCartNum(that.shoppCartProductList[index].id, number)
    },

    /**
     * 提交
     */
    sunmitEnquiry() {
      let that = this;
      if (that.submitInfo.email == "") {
        this.$message.warning(
          that.currLanguage == 3
            ? "Please fill in the mailboxe"
            : this.pageTextArr[23]
        );
      } else if (that.submitInfo.commit == "") {
        this.$message.warning(
          that.currLanguage == 3
            ? "Please fill in the contents"
            : this.pageTextArr[24]
        );
      } else {
        that.submitProductConsult();
      }
    },

    /**
     * 疑问
     */
    submitProductConsult() {
      let that = this;
      let data = {
        name: "",
        email: that.submitInfo.email,
        mobile: "",
        content: that.submitInfo.commit,
        pics: that.uploadImgData.join(","),
        product_id: that.productId,
        nasku_numberme: that.currProductSkuNumber,
        type: 2, //1为询价2为疑问
      };
      this.$http.submitProductConsult(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success("success");
            that.uploadImgData = [];
            that.submitInfo.email = "";
            that.submitInfo.commit = "";
            that.isShowDialogDoubt = false;
          } else {
            this.$message.error("error");
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 处理APIde数据进行翻译
     * @param {*} data
     */
    translateApiData(data, lev, type) {
      let that = this;
      let newTextArr = [];
      if (type == "productinfo") {
        //商品信息翻译
        newTextArr.push(data.title);
        newTextArr.push(data.secondtitle);
        newTextArr.push(data.body);
        that.languageTranslateByArr(newTextArr, 1, type);
      } else if (type == "portfolioList") {
        //组合商品名翻译
        data.forEach((v, i) => {
          newTextArr.push(v.title);
        });

        let childrenTextArr = [];
        // debugger
        that.portfolioList.forEach((v, i) => {
          // console.log('v', v.level1.children);
          if (v.product != undefined && v.product.length > 0) {
            v.product.forEach((v2, i2) => {
              childrenTextArr.push(i + "@" + i2 + "@" + v2.title);
            });
          }
        });
        that.languageTranslateByArr(childrenTextArr, 2, type);
      } else {
        //商品规格属性信息翻译
        data.forEach((v, i) => {
          newTextArr.push(v.specification_name);
        });
        console.log(type, 1661);
        that.languageTranslateByArr(newTextArr, 1, type);

        let childrenTextArr = [];
        // debugger
        that.skuProductPriceData.forEach((v, i) => {
          // console.log('v', v.level1.children);
          if (v.values != undefined && v.values.length > 0) {
            v.values.forEach((v2, i2) => {
              childrenTextArr.push(i + "@" + i2 + "@" + v2.specification_value);
            });
          }
        });
        that.languageTranslateByArr(childrenTextArr, 2, type);
      }
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, lev, type) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data, lev, type);
        },
        (res) => { }
      );
    },
    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, lev, type) {
      let that = this;
      if (type == "productinfo") {
        that.profuctInfoData.title = data[0].translation;
        that.profuctInfoData.secondtitle = data[1].second_title;
        that.profuctInfoData.body = data[2].translation;
      } else if (type == "portfolioList") {
        data.forEach((v, i) => {
          switch (lev) {
            case 2:
              let childIndex = 0;
              let lastIndex = 0;
              data.forEach((v, i) => {
                let index = v.query.split("@")[0];
                let childIndex = v.query.split("@")[1];
                that.portfolioList[index].product[childIndex].title =
                  v.translation.split("@")[2];
              });
              break;

            default:
              break;
          }
        });
      } else {
        data.forEach((v, i) => {
          switch (lev) {
            // 分类一级数据
            case 1:
              data.forEach((v, i) => {
                that.skuProductPriceData[i].specification_name = v.translation;
              });
              break;
            //分类二级数据
            case 2:
              let childIndex = 0;
              let lastIndex = 0;
              data.forEach((v, i) => {
                let index = v.query.split("@")[0];
                let childIndex = v.query.split("@")[1];
                that.skuProductPriceData[index].values[
                  childIndex
                ].specification_value = v.translation.split("@")[2];
              });
              break;

            default:
              break;
          }
        });
      }
    },

    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr, type) {
      let that = this;
      let newpagetextArr = [];
      if (type == 1) {
        that.translateByArr(arr, (res) => {
          console.log("res", res);
          res.data.forEach((item, index) => {
            newpagetextArr.push(item.translation);
          });
          that.pageTextArr = newpagetextArr;
        });
      } else {
        let comment = [];
        arr.forEach((item, index) => {
          comment.push(item.comment);
        });

        that.translateByArr(comment, (res) => {
          res.data.forEach((item, index) => {
            that.productCommentList[index].comment = item.translation;
          });
        });
      }
    },

    /**
     * 商品分类
     */
    getCategoryList() {
      let that = this;
      let data = {
        page: 1,
        pagesize: 1000,
      };
      this.$http.getCategoryList(data, (res) => {
        if (res.ret == 1) {
          that.categoryList = res.data;
          console.log(" that.categoryList", that.categoryList)
        }
      });
    },

    /**
     * 跳转个人中心
     */
    toPersonCenter(index, item) {
      if (index == 0) {
        this.$router.push({
          path: "/",
        });
      } else if (index == 1) {
        this.$router.push({
          path: "/productShow",
        });
      } else if (index == 2) {
        let levId = item.id;
        let index = null;
        this.categoryList.forEach((item, i) => {
          if (item.id == levId) {
            index = i
          }
        })
        this.$router.push({
          path: "/productShow",
          query: {
            currProductTypeId: levId,
            index: index,
            levId: levId,
            pageStaus: 1,
          },
        });
      } else if (index == 3) {

        let levId = item.parentid;
        let index = null;
        this.categoryList.forEach((item, i) => {
          if (item.id == levId) {
            index = i
          }
        })
        this.$router.push({
          path: "/productShow",
          query: {
            currProductTypeId: item.id,
            index: index,
            levId: levId,
            pageStaus: 1,
          },
        });
      }
    },
    /**
     * 处理APIde数据进行翻译
     * @param {*} data
     */
    translateApiData1(data, title, type) {
      let that = this;
      let newTextArr = [];

      data.forEach((v, i) => {
        for (const key in v) {
          if (key == title) {
            newTextArr.push(v[key]);
          }
        }
      });
      that.languageTranslateByArr(newTextArr, title, type);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, title, type) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data, title, type);
        },
        (res) => { }
      );
    },
    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, title, type) {
      let that = this;
      data.forEach((v, i) => {
        switch (type) {
          case -1:
            that.menuBar[i][title] = v.translation;
            break;
          default:
            break;
        }
      });
    },
  },
  mounted() {
    let that = this;
    let url = window.location.href
    console.log("url", url)
    localStorage.setItem("url", url)
    that.headerData = {
      accesstoken: localStorage.getItem("token"),
    };
    // 判断是手机还是PC
    that.judgePcOrPhone();
    // 当前语言
    that.currLanguage = localStorage.getItem("curLanguageType");
    // 产品详情ID
    that.productId = that.$route.query.product_id;
    // 产品详情
    that.getProductDetail();
    that.languageTranslateByArrs(that.pageTextArr, 1);
    that.getCategoryList();

    // $('body,html').animate({scrollTop: 0}, 1000);
    // console.log(window.innerHeight)

  },
};
</script>
<style>
@import "../assets/fonts/fonts.css";
</style>


// WEBPACK FOOTER //
// src/view/productDetail.vue